/*
* Фиксирует высоту селекта при выпадении
* Это нужно, например, в меню онлайна
*
* */


var fixSelect = function(el){
	var select = el.querySelector('[data-fixSelect-select]'),
		hide = function(){
			el.classList.remove('js-focus');
			select.removeAttribute('size');
		},
		show = function(){
			el.classList.add('js-focus');
			select.setAttribute('size', 5);
		};

	//
	if(navigator.userAgent.indexOf('Edge') !== -1) return false; /* В ие при выборе селекта и так ничего не пряяется */

	select.onmousedown = function(e){
		if(!el.classList.contains('js-focus')) e.preventDefault();
	}

	select.onclick = function(){
		if(el.classList.contains('js-focus')) hide();
		else show();
	}
}

export {fixSelect};
